import { gql } from '@apollo/client';

export const deleteSearchHistory = gql`
  mutation deleteSearchHistory($id: ID!) {
    deleteSearchHistory(where: { id: $id }) {
      id
    }
  }
`;
